import { Box } from '@mui/material';
import { ILaboratoryDetails } from 'Reducers/LaboratoryReducer/ILaboratoryReducer';
import React from 'react';

interface IDocumentLatterHeadProps {
  laboratory: ILaboratoryDetails | null;
}

export default function DocumentLatterHead(props: IDocumentLatterHeadProps) {
  if (!props.laboratory) return null;

  const address = props.laboratory.details.address;
  const addressSegments = [address?.line1, address?.line2, address?.city].filter(Boolean);

  if (address?.state && address?.zip) {
    addressSegments.push(`${address.state} - ${address.zip}`);
  } else if (address?.state) {
    addressSegments.push(address.state);
  } else if (address?.zip) {
    addressSegments.push(`${address.zip}`);
  }

  return (
    <Box display={'flex'} border={'1px solid #000'} p={2}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 'bold' }}>{props.laboratory.details.name}</div>

        <div style={{ fontSize: 14 }}>{addressSegments.join(', ')}</div>

        {/* Email | Phone | Website in SAME LINE */}
        <div
          style={{
            display: 'flex',
            gap: '12px',
            fontSize: 13,
            marginTop: 4,
            flexWrap: 'wrap', // important for small widths / print
          }}
        >
          <span>Email: {props?.laboratory?.details?.email || 'NA'}</span>
          &nbsp;|&nbsp;
          <span>Website: {props?.laboratory?.details?.website || 'NA'}</span>
          &nbsp;|&nbsp;
          <span>Mo. No: {props?.laboratory?.details?.phone || 'NA'}</span>
        </div>
      </div>

      <div>
        <img src={props.laboratory.details.logo} alt="logo" style={{ width: '40mm', objectFit: 'contain' }} />
      </div>
    </Box>
  );
}
